<template>
    <div>
        <transition name="slide-right">
            <div v-if="isCartOpen" class="cart-sidebar">
                <div class="cart-header">
                    <h3>{{ $t('Your Cart') }}</h3>
                    <button @click="toggleCart" class="close-btn" aria-label="Close cart">
                        ×
                    </button>
                </div>

                <div v-if="cartItems.length > 0" class="cart-items">
                    <div v-for="item in cartItems" :key="item.id" class="cart-item">
                        <img v-if="item.image" :src="getImgUrl(item.image)" class="item-image">
                        <v-icon v-else class="item-image"> </v-icon>       
                        <div class="item-details">
                            <h4 class="item-name">{{ item.name }}</h4>
                            <p class="item-price">
                                {{ websiteSettings.COIN_CODE }}{{ (item.price * (1 - (item.discount || 0) / 100)).toFixed(2) }}
                                <span v-if="item.discount" class="discount">-{{ item.discount }}%</span>
                            </p>

                            <div class="quantity-controls">
                                <button @click="decreaseQuantity(item.id)" class="qty-btn">-</button>
                                <span class="qty">{{ item.quantity }}</span>
                                <button @click="increaseQuantity(item.id)" class="qty-btn">+</button>
                            </div>
                        </div>

                        <button @click="removeItem(item.id)" class="remove-btn" aria-label="Remove item">
                            ×
                        </button>
                    </div>
                </div>

                <div v-else class="empty-cart">
                    <p>Your cart is empty</p>
                </div>

                <div v-if="cartItems.length > 0" class="cart-footer">
                    <div class="cart-total">
                        <span>Total:</span>
                        <span class="total-amount">{{ websiteSettings.COIN_CODE }}{{ cartTotal }}</span>
                    </div>
                    <button @click="goToCheckout" class="checkout-btn" :disable="loadingOrder" >
                        {{ loadingOrder ? $t('Confirm Order...') : $t('Confirm Order') }}
                    </button>
                </div>
            </div>
        </transition>

        <div v-if="isCartOpen" class="cart-overlay" @click="toggleCart"></div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'CartSidebar',
    data () {
        return {
            loadingOrder: false,
        }
    },
    computed: {
        ...mapState({
            isCartOpen: state => state.cart.isCartOpen,
            websiteSettings: state => state.websiteSettings
        }),
        ...mapGetters({
            cartItems: 'cart/cartItems',
            cartTotal: 'cart/cartTotal'
        })
    },
    methods: {
        getImgUrl(item) {
            let domain = `${this.$store.state.serverDomain}/storage/`;
            return domain + item;
        }, 
        ...mapMutations({
            toggleCart: 'cart/TOGGLE_CART'
        }),
        removeItem(productId) {
            this.$store.commit('cart/REMOVE_FROM_CART', productId)
        },
        increaseQuantity(productId) {
            const item = this.cartItems.find(item => item.id === productId)
            if (item) {
                this.$store.commit('cart/UPDATE_QUANTITY', {
                    productId,
                    quantity: item.quantity + 1
                })
            }
        },
        decreaseQuantity(productId) {
            const item = this.cartItems.find(item => item.id === productId)
            if (item && item.quantity > 1) {
                this.$store.commit('cart/UPDATE_QUANTITY', {
                    productId,
                    quantity: item.quantity - 1
                })
            } else {
                this.removeItem(productId)
            }
        },
        async goToCheckout() {
            this.loadingOrder = true;
            try {
                let params = this.cartItems.map((el)=>{
                    return {
                        product_id: el.id,
                        quantity: el.quantity,
                    }
                });
                let postData = {
                    date: new Date().toISOString().split('T')[0],
                    items: params
                }
                await axios.post('/b2c/order',postData);
                this.$store.commit('cart/CLEAR_CART');
                this.$Notifications(
                    this.$t('add success'),
                    { rtl: true, timeout: 2000 },
                    "success"
                );
                this.toggleCart();
            } catch (error) { }
            this.loadingOrder = false;

            // this.toggleCart()
            // this.$router.push('/e-commerce-web/checkout')
        }
    }
}
</script>

<style scoped>
.cart-sidebar {
    position: fixed;
    top: 0;
    right: 0;
    width: 350px;
    height: 100vh;
    background: white;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    z-index: 1001;
    display: flex;
    flex-direction: column;
}

.cart-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

.cart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #e9ecef;
}

.cart-header h3 {
    margin: 0;
    font-size: 20px;
    color: #333;
}

.close-btn {
    background: none;
    border: none;
    font-size: 28px;
    cursor: pointer;
    color: #666;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background 0.3s ease;
}

.close-btn:hover {
    background: #f8f9fa;
}

.cart-items {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
}

.cart-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #f1f1f1;
}

.item-image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 8px;
    margin-right: 15px;
}

.item-details {
    flex: 1;
}

.item-name {
    margin: 0 0 5px 0;
    font-size: 14px;
    font-weight: 600;
}

.item-price {
    margin: 0 0 10px 0;
    font-size: 16px;
    font-weight: 700;
    color: #2ed573;
}

.discount {
    background: #ff4757;
    color: white;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    margin-left: 5px;
}

.quantity-controls {
    display: flex;
    align-items: center;
    gap: 10px;
}

.qty-btn {
    width: 25px;
    height: 25px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 50%;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.qty {
    font-size: 16px;
    font-weight: 600;
}

.remove-btn {
    background: none;
    border: none;
    color: #ff4757;
    font-size: 20px;
    cursor: pointer;
    padding: 5px;
    border-radius: 50%;
    transition: background 0.3s ease;
}

.remove-btn:hover {
    background: #ffeaea;
}

.empty-cart {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty-cart p {
    color: #666;
    font-size: 18px;
}

.cart-footer {
    padding: 20px;
    border-top: 1px solid #e9ecef;
}

.cart-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
}

.total-amount {
    color: #2ed573;
    font-size: 24px;
}

.checkout-btn {
    width: 100%;
    padding: 15px;
    background: #2ed573;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.3s ease;
}

.checkout-btn:hover {
    background: #26c463;
}

.slide-right-enter-active,
.slide-right-leave-active {
    transition: transform 0.3s ease;
}

.slide-right-enter-from,
.slide-right-leave-to {
    transform: translateX(100%);
}

@media (max-width: 480px) {
    .cart-sidebar {
        width: 100%;
        max-width: 350px;
    }
}
</style>